export const Routes = {
  // pages
  Presentation: { path: "/dashboard/overview" },
  DashboardOverview: { path: "/dashboard/overview" },
  Transactions: { path: "/reports" },
  SubAdmin: { path: "/users" },
  Settings: { path: "/settings" },
  BootstrapTables: { path: "/tables/constant-tables" },
  NewReports: { path: "/new-reports" },
  Billing: { path: "/page/billing" },
  Invoice: { path: "/page/invoice" },
  Signin: { path: "/sign-in" },
  ForgotPassword: { path: "/auth/forgot-password" },
  ResetPassword: { path: "/auth/password-reset/:token" },
  ProfileSetup: { path: "/auth/profile-setup/:token" },
  NotFound: { path: "/auth/404" },
  ServerError: { path: "/auth/500" },
  ReportHistory: { path: "./components/ReportHistory.jsx" },
  ReportResult: { path: "/components/ReportHistory" },
  ReportHistoryEdit: { path: "/new-reports/edit" },
  ProjectInput: { path: "/project-input" },
  Customization: { path: "/customization" },
  NDAForm: { path: "/nda-form-Customization" },
  EntityTable: { path: "/entity-info" },
  ProformaUsers: { path: "/proforma-users" },
  ContactOwner: { path: "/contact-owner" },
  Assets: { path: "/assets" },
  AssetsV2: { path: "/assets-v2" },
  AssetAudit: { path: "/assets-audit" },
  AssetLogs: { path: "/asset-logs" },
  ProductionReporting: { path: "/production-reporting" },
  ProductionReportingV2: { path: "/production-reporting-v2" },
  ProductionReportLogs: { path: "/production-report-logs" },
  AccessControl: { path: "/access-control" },
  USERJourney: { path: "/user-journey" },
  TrancheBot: { path: "/tranche-bot" },
  TrancheBotV2: { path: "/tranche-bot-v2" },
  ProposedAssets: { path: "/tranche-bot-v2/proposed-assets" },
  ApprovedTranche: { path: "/tranche-bot-v2/approved-tranches/:trancheId" },
  TsaBackend: { path: "/tsa-backend" },
  ProformaGenerations: { path: "/proforma-generations" },
  TsaBilling: { path: "/tsa-billing" },
  Tranches: { path: "/tranches" },
  TrancheAnalytics: { path: "/tranche-bot-v2/analytics" },
  Contacts: { path: "/contacts" },
  PandCDocuments: { path: "/p-and-c-documents" },
  ReportsCenter: { path: "/reports-center" },
  DivisorLookup: { path: "/divisor-lookup" },
  AssetsUnderwriting: { path: "/assets-underwriting" },
  Profile: { path: "/profile" },
  PartnerDocument: { path: "/partner-documents" },
  ProductionMonitoringAndReporting: {
    path: "/production-monitoring-and-reporting",
  },
  ProductionMonitoringAndReportingV2: {
    path: "/production-monitoring-and-reporting-v2",
  },
  ProductionReportingDataV2: {
    path: "/production-reporting-data-v2",
  },
  ProductionReportingData: {
    path: "/production-reporting-data",
  },
  TicketCenter: { path: "/ticket-center" },
  TicketPage: { path: "/ticket-center/:ticketId" },
  PowerBI: { path: "/power-bi" },
  PowerBIPermission: { path: "/power-bi-permission" },
  PurlMarketingResources: { path: "/purl-marketing-resources" },
  KnowledgeBase: { path: "/knowledge-base" },
  KnowledgeGap: { path: "/knowledge-gap" },
  UserInteraction: { path: "/user-interaction" },
  UserInteractionDetail: { path: "/user-interaction/:interactionId" },
  M1M2Documents: { path: "/m1-m2-documents" },
  AssetArchiveFiles: { path: "/asset-archive-files" },
  MasterUsers: { path: "/master-users" },
};
